module.exports = __webpack_public_path__ + "static/media/Bot1.67a4b484.png";